export function timeFormat(seconds) {
    const MINUTE = 60;
    const HOUR = 60 * 60;
    const ss = ~~seconds % MINUTE;
    const ms = ~~((seconds - ~~seconds) * 1000);
    const mm = ~~((seconds % HOUR) / MINUTE);
    const hh = ~~(seconds / HOUR);

    return `${addCeroToNumber(hh)}:${addCeroToNumber(mm)}:${addCeroToNumber(ss)}:${addCeroToNumber(ms, 3)}`;
}

export function addCeroToNumber(str, num = 2, pad = "0") {
    str = "" + str;
    while (str.length < num) {
        str = pad + str;
    }
    return str;
}
